import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  ButtonGroup,
  InputGroup,
  InputGroupText,
} from "reactstrap";

import Submit from "assets/icon/Submit.svg";
import useAxios from "hooks/useAxios";
import { dateFormate, datetimeformate } from "utils/columns";

const AddUpdate = (props) => {
  const { loading, setLoading, caseAttachment, selectedRow,setAttachment } = props;
  const API = useAxios()
  const [description, setDescription] = useState("")
  const handelDescrption = (e) => {
    const { value } = e.target
    setDescription(value)

  }
  const handelCaseData=async()=>{
    const paylod={}
          setLoading(true)

     paylod.caseId = selectedRow.caseId
    paylod.opaCode = selectedRow.opaCode
    try{
      const {data}=await API.post(`/api/Search/casedata`,paylod)
      setAttachment(data)
            setLoading(false)

      // console.log(data,"data")
    }
    catch(error){
            setLoading(false)

      console.log(error)
    }

  }
  useEffect(()=>{

  },[caseAttachment])
  console.log(caseAttachment,"caseAttachments")
const getSessionStorageDetails = () => {
  return JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
};
const { token_type, access_token,profile } = getSessionStorageDetails();
  console.log(profile,"profile")
 
  const handleSubmit = async () => {
    const paylod = {}
    // paylod.caseId = "500cZ000006f8ZGQAY"
    paylod.caseId = selectedRow.caseId
    paylod.customerUpdates = description
     paylod.customerEmail=profile.username
    try {

      const { data } = await API.post(`/api/Search/addcustomerupdates`, paylod,)
      if (data) {
        setDescription("")
        handelCaseData()
      }
    }
    catch (error) {
      console.log(error)
    }
    // console.log(data,)
    // if (data) {
    //   setAttachment(data)
    // }

  }
  return (
    <div>
      <Row>
        <Col md={12} lg={12} sm={12} xs={12}>
          <FormGroup>
            <Label for="descrption"
            style={{paddingTop:"0px",paddingBottom:"4px"}}>You can add updates and comments to this case here. Once an update is submitted, your account manager will be notified via email.</Label>
            <Input
              id="descrption"
              name="descrption"
              type="textarea"
              onChange={handelDescrption}
              value={description}
              placeholder="Enter Updates"
              // disabled={!selectedCasesubreason.length}
              autoComplete="off"
              className="cu-de-textarea"
            />
          </FormGroup>
        </Col>

        <Col sm={0} className="d-flex" style={{ justifyContent: "flex-end" }}>
          <Label>{""}</Label>
          <Button
            color="primary"
            className="search"
            onClick={handleSubmit}
            disabled={description.length == 0}
          >
            <span className='right_5'> <img src={Submit} alt="" /></span>
            Update
          </Button>
        </Col>
      </Row>
        <div className="customer-update">
          {caseAttachment?.customerUpdates?.map((item) => {
        return (
        
            <div className="mb-3" 
          // style={{borderBottom:"1px solid #c6c6c6"}}
          >
            <p className="f-14 mb-2" style={{ color: "#212121" }}>{item.customerUpdatedValue}</p>
            <div className="d-flex justify-content-between" style={{paddingBottom:"4px"}}>
              <span className="f-14 font-weight-600" style={{ color: "#757575" }}>{item.customerEmail}</span>
              <span className="f-14 font-weight-600" style={{ color: "#757575" }}>{datetimeformate(item.createdDateAndTime)}</span>
            </div>
          </div>
         
          
        )
      })}
       </div>


    </div>
  )
}

export default AddUpdate